(function () {
  let bundleSwitchRequestId = 0;

  window.PDPSwiperSlider = {
    init(scope) {
      const root = scope instanceof Element ? scope : document;
      const sliders = root.querySelectorAll('.pdSwiperSlider');

      sliders.forEach((slider) => {
        this.destroySingle(slider);
        this.initSingle(slider);
      });
    },

    initSingle(slider) {
      if (!slider || slider.dataset.pdpSwiperInitialized === 'true') return;

      const thumbsContainer = slider.querySelector('.slider__thumbs .swiper-container');
      const imagesContainer = slider.querySelector('.slider__images .swiper-container');
      const nextBtn = slider.querySelector('.slider__next');
      const prevBtn = slider.querySelector('.slider__prev');

      if (!thumbsContainer || !imagesContainer) return;

      const sliderThumbs = new Swiper(thumbsContainer, {
        direction: 'vertical',
        slidesPerView: 5,
        freeMode: true,
        watchSlidesProgress: true,
        watchSlidesVisibility: true,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn
        },
        breakpoints: {
          0: {
            direction: 'horizontal'
          },
          768: {
            direction: 'vertical'
          }
        },
        on: {
          init: function () {
            playActiveSlideVideo(this);
          },
          slideChange: function () {
            playActiveSlideVideo(this);
          },
          update: function () {
            playActiveSlideVideo(this);
          }
        }
      });

      const sliderImages = new Swiper(imagesContainer, {
        direction: 'vertical',
        slidesPerView: 1,
        mousewheel: true,
        grabCursor: true,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn
        },
        thumbs: {
          swiper: sliderThumbs
        },
        breakpoints: {
          0: {
            direction: 'horizontal'
          },
          768: {
            direction: 'vertical'
          }
        },
        on: {
          init: function () {
            playActiveSlideVideo(this);
          },
          slideChange: function () {
            playActiveSlideVideo(this);
          },
          update: function () {
            playActiveSlideVideo(this);
          }
        }
      });

      slider._pdpThumbsSwiper = sliderThumbs;
      slider._pdpImagesSwiper = sliderImages;
      slider.dataset.pdpSwiperInitialized = 'true';

      setSliderHeight(slider);

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          if (slider._pdpThumbsSwiper) slider._pdpThumbsSwiper.update();
          if (slider._pdpImagesSwiper) slider._pdpImagesSwiper.update();
          setSliderHeight(slider);
        });
      });

      setTimeout(() => {
        if (slider._pdpThumbsSwiper) slider._pdpThumbsSwiper.update();
        if (slider._pdpImagesSwiper) slider._pdpImagesSwiper.update();
        setSliderHeight(slider);
      }, 200);
    },

    destroy(scope) {
      const root = scope instanceof Element ? scope : document;
      const sliders = root.querySelectorAll('.pdSwiperSlider');

      sliders.forEach((slider) => {
        this.destroySingle(slider);
      });
    },

    destroySingle(slider) {
      if (!slider) return;

      if (slider._pdpImagesSwiper && typeof slider._pdpImagesSwiper.destroy === 'function') {
        try {
          slider._pdpImagesSwiper.destroy(true, true);
        } catch (e) {
          console.warn('Images swiper destroy failed:', e);
        }
        slider._pdpImagesSwiper = null;
      }

      if (slider._pdpThumbsSwiper && typeof slider._pdpThumbsSwiper.destroy === 'function') {
        try {
          slider._pdpThumbsSwiper.destroy(true, true);
        } catch (e) {
          console.warn('Thumbs swiper destroy failed:', e);
        }
        slider._pdpThumbsSwiper = null;
      }

      slider.dataset.pdpSwiperInitialized = 'false';

      slider.querySelectorAll('.swiper-container').forEach((container) => {
        container.classList.remove(
          'swiper-initialized',
          'swiper-horizontal',
          'swiper-vertical',
          'swiper-backface-hidden',
          'swiper-thumbs'
        );
        container.removeAttribute('style');
      });

      slider.querySelectorAll('.swiper-wrapper').forEach((wrapper) => {
        wrapper.removeAttribute('style');
      });

      slider.querySelectorAll('.swiper-slide').forEach((slide) => {
        slide.removeAttribute('style');
        slide.classList.remove(
          'swiper-slide-thumb-active',
          'swiper-slide-visible',
          'swiper-slide-active',
          'swiper-slide-next',
          'swiper-slide-prev'
        );
      });
    }
  };

  function playActiveSlideVideo(swiper) {
    if (!swiper || !swiper.slides) return;

    swiper.slides.forEach((slide) => {
      const video = slide.querySelector('video');
      if (video) {
        video.pause();
      }
    });

    const activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return;

    const activeVideo = activeSlide.querySelector('video');
    if (activeVideo) {
      activeVideo.currentTime = 0;
      activeVideo.play().catch(() => {});
    }
  }

  function setSliderHeight(scope) {
    const root = scope instanceof Element ? scope : document;
    const sliderImagesContainer = root.querySelector('.slider__images .swiper-container');

    if (!sliderImagesContainer) return;

    if (window.innerWidth >= 768) {
      sliderImagesContainer.style.height = `${window.innerHeight * 0.9}px`;
    } else {
      sliderImagesContainer.style.height = 'auto';
    }
  }

  function waitForSectionImages(sectionEl) {
    const images = Array.from(sectionEl.querySelectorAll('img'));

    if (!images.length) return Promise.resolve();

    return Promise.all(
      images.map((img) => {
        if (img.complete) return Promise.resolve();

        return new Promise((resolve) => {
          const done = () => resolve();
          img.addEventListener('load', done, { once: true });
          img.addEventListener('error', done, { once: true });
        });
      })
    );
  }

  function getBundleOrder(sectionEl) {
    const bundleList = sectionEl.querySelector('.bundle-product-list');
    if (!bundleList) return [];

    return Array.from(bundleList.querySelectorAll('.bundle-product-item'))
      .map((item) => {
        return item.dataset.productId || item.dataset.productHandle || '';
      })
      .filter(Boolean);
  }

  function preserveBundleOrder(oldSectionEl, newSectionEl) {
    const oldBundleList = oldSectionEl.querySelector('.bundle-product-list');
    const newBundleList = newSectionEl.querySelector('.bundle-product-list');

    if (!oldBundleList || !newBundleList) return;

    const oldOrder = getBundleOrder(oldSectionEl);
    if (!oldOrder.length) return;

    const newItems = Array.from(newBundleList.querySelectorAll('.bundle-product-item'));
    if (!newItems.length) return;

    const itemMap = new Map();

    newItems.forEach((item, index) => {
      const key = item.dataset.productId || item.dataset.productHandle || `__index_${index}`;
      itemMap.set(key, item);
    });

    const orderedItems = [];

    oldOrder.forEach((key) => {
      if (itemMap.has(key)) {
        orderedItems.push(itemMap.get(key));
        itemMap.delete(key);
      }
    });

    itemMap.forEach((item) => {
      orderedItems.push(item);
    });

    orderedItems.forEach((item) => {
      newBundleList.appendChild(item);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (window.PDPSwiperSlider) {
      window.PDPSwiperSlider.init(document);
    }
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('.pdSwiperSlider').forEach((slider) => {
      setSliderHeight(slider);

      if (slider._pdpThumbsSwiper) slider._pdpThumbsSwiper.update();
      if (slider._pdpImagesSwiper) slider._pdpImagesSwiper.update();
    });
  });

  document.addEventListener('change', async function (event) {
    const radio = event.target.closest('.bundle-product-item input[type="radio"]');
    if (!radio) return;

    const bundleItem = radio.closest('.bundle-product-item');
    if (!bundleItem) return;

    const productUrl = bundleItem.dataset.productUrl;
    if (!productUrl) return;

    const currentSectionEl = bundleItem.closest('[id^="shopify-section-"]');
    if (!currentSectionEl) return;

    const sectionId = currentSectionEl.id.replace('shopify-section-', '');
    if (!sectionId) return;

    if (currentSectionEl.classList.contains('is-loading')) return;

    bundleItem.classList.add('is-switching');
    currentSectionEl.classList.add('is-loading');

    const requestId = ++bundleSwitchRequestId;

    try {
      if (window.PDPSwiperSlider) {
        window.PDPSwiperSlider.destroy(currentSectionEl);
      }

      const response = await fetch(`${productUrl}?section_id=${sectionId}`, {
        method: 'GET',
        credentials: 'same-origin',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      if (!response.ok) {
        throw new Error(`Failed to load section HTML: ${response.status}`);
      }

      const htmlText = await response.text();

      if (requestId !== bundleSwitchRequestId) return;

      const parsedDocument = new DOMParser().parseFromString(htmlText, 'text/html');
      const newSectionEl = parsedDocument.querySelector(`#shopify-section-${sectionId}`);

      if (!newSectionEl) {
        throw new Error(`Section #shopify-section-${sectionId} not found in response.`);
      }

      const oldSectionEl = document.querySelector(`#shopify-section-${sectionId}`);
      if (!oldSectionEl) {
        throw new Error(`Current section #shopify-section-${sectionId} not found.`);
      }

      preserveBundleOrder(oldSectionEl, newSectionEl);

      oldSectionEl.replaceWith(newSectionEl);

      if (requestId !== bundleSwitchRequestId) return;

      await waitForSectionImages(newSectionEl);

      if (requestId !== bundleSwitchRequestId) return;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          try {
            if (
              window.PXUTheme &&
              window.PXUTheme.jsProduct &&
              typeof window.PXUTheme.jsProduct.init === 'function' &&
              window.jQuery
            ) {
              window.PXUTheme.jsProduct.init(window.jQuery(newSectionEl));
            }
          } catch (e) {
            console.warn('Theme product init failed:', e);
          }

          try {
            if (
              window.Shopify &&
              window.Shopify.PaymentButton &&
              typeof window.Shopify.PaymentButton.init === 'function'
            ) {
              window.Shopify.PaymentButton.init();
            }
          } catch (e) {
            console.warn('Payment button init failed:', e);
          }

          try {
            if (
              window.ShopifyXR &&
              typeof window.ShopifyXR.setupXRElements === 'function'
            ) {
              window.ShopifyXR.setupXRElements();
            }
          } catch (e) {
            console.warn('Shopify XR init failed:', e);
          }

          try {
            if (window.PDPSwiperSlider) {
              window.PDPSwiperSlider.init(newSectionEl);
            }
          } catch (e) {
            console.warn('Custom PDP Swiper init failed:', e);
          }

          setTimeout(() => {
            try {
              if (window.PDPSwiperSlider) {
                window.PDPSwiperSlider.destroy(newSectionEl);
                window.PDPSwiperSlider.init(newSectionEl);
              }
            } catch (e) {
              console.warn('Delayed PDP Swiper init failed:', e);
            }
          }, 200);
        });
      });

      if (window.history && window.history.replaceState) {
        window.history.replaceState({}, '', productUrl);
      }

      document.dispatchEvent(
        new CustomEvent('bundle:product-switched', {
          detail: {
            productId: bundleItem.dataset.productId,
            productHandle: bundleItem.dataset.productHandle,
            variantId: bundleItem.dataset.firstVariantId,
            productUrl,
            sectionId
          }
        })
      );
    } catch (error) {
      console.error('Bundle switch failed:', error);
    } finally {
      bundleItem.classList.remove('is-switching');

      const sectionAfterReplace = document.querySelector(`#shopify-section-${sectionId}`);
      if (sectionAfterReplace) {
        sectionAfterReplace.classList.remove('is-loading');
      }
    }
  });

  $(document).ready(function () {
    $(document).on('click', '.swatch__option label', function () {
      $(this)
        .find('.tooltipData')
        .show()
        .parents('.swatch__option')
        .siblings('.swatch__option')
        .find('.tooltipData')
        .hide();
    });

    $('.j1q-N').click(function () {
      $('.cutmStaxtx').toggleClass('active');
    });

    $('.j1q-N').click(function () {
      var $this = $(this);
      $this.toggleClass('SeeMore2');
      if ($this.hasClass('SeeMore2')) {
        $this.text('Show more...');
      } else {
        $this.text('Show less...');
      }
    });

    $(document).on('click', '[JSUpsellsCart]', function (e) {
      e.preventDefault();
      var mainObjj = $(this),
        dataProductId = $(this).parents('.product-block-additional-product').attr('data-productghPdp');
      $(this).attr('checked', true);
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        method: 'Post',
        data: {
          id: $(this).val(),
          quantity: 1
        },
        success: function () {
          $.ajax({
            url: '/cart.js',
            dataType: 'json',
            success: function (cart) {
              cart.items.forEach(function (item) {
                if (dataProductId == item.product_id) {
                  $('.product-block-additional-product[data-productghPdp="' + dataProductId + '"]').addClass('hide');
                }
              });
              mainObjj.attr('checked', true);
              var itemsCount = cart.item_count;
              $('.header-cart').addClass('has-cart-count');
              $('.header-cart__count').html(itemsCount);
              $('.header-cart__icon').addClass('has-cart-count');
              $('.header-cart__count').html(itemsCount);
            }
          });
        }
      });
    });

    document.addEventListener('UPEZ__CART_REFETCHED_AFTER_CHANGE', (e) => {
      const cart = e.detail.cart;
      const getCartItem = [];
      if (cart.item_count > 0) {
        cart.items.forEach(function (item) {
          getCartItem.push(item.product_id);
        });
      } else {
        document.querySelectorAll('.product-block-additional-product').forEach((elm) => {
          elm.classList.remove('hide');
        });
      }
      document.querySelectorAll('.product-block-additional-product').forEach((elm) => {
        var checkElm = parseInt(elm.getAttribute('data-productghpdp'));
        if (getCartItem.indexOf(checkElm) !== -1) {
          console.log(checkElm);
          elm.classList.add('hide');
        } else {
          elm.classList.remove('hide');
        }
      });
    });

    document.querySelectorAll('.tab-link').forEach((link) => {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        document.querySelectorAll('.tab-link').forEach(function (tab) {
          tab.parentNode.classList.remove('active');
        });
        this.parentNode.classList.add('active');
        const targetId = this.getAttribute('href');
        const targetElement = document.querySelector(targetId);
        $(targetId)
          .children('.detailsDescrips')
          .slideDown()
          .parent('.tab-content')
          .addClass('active')
          .siblings('.tab-content')
          .removeClass('active')
          .children('.detailsDescrips')
          .slideUp();
        targetElement.parentNode.scrollIntoView({
          behavior: 'smooth'
        });
      });
    });

    $(document).on('click', '.detailsDescripss', function (e) {
      e.preventDefault();
      $(this)
        .siblings('.detailsDescrips')
        .slideToggle()
        .parent('.tab-content')
        .toggleClass('active')
        .siblings('.tab-content')
        .removeClass('active')
        .children('.detailsDescrips')
        .slideUp();
    });
  });
})();